export default "__VITE_ASSET__570a335d__"